module.exports = __webpack_public_path__ + "img/whoweare_desktop.dca6a76a.png";